import {Route, BrowserRouter as Router, Routes} from 'react-router-dom';
import Header from './components/Header';
import Footer from "./components/Footer";
import Services from "./components/Services";
import Contact from "./components/Contact"; 
import Home from "./components/Home"; 
import ScrollToTop from './components/ScrollToTop';

import './styles/App.scss';
import './styles/colors.scss';
import './styles/contact.scss';
import './styles/footer.scss';
import './styles/header.scss';
import './styles/home.scss';
import './styles/mediaquery.scss';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
